import React, { forwardRef } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/links';
type CTAButtonProps = {
  label: string;
  sublabel?: string;
  tone?: 'light' | 'dark';
  className?: string;
};
export const CTAButton = forwardRef<HTMLAnchorElement, CTAButtonProps>(function CTAButton({
  label,
  sublabel,
  tone = 'light',
  className = ''
}, ref) {
  return <div className={`flex w-full flex-col items-center ${className}`} data-id="element-101" data-mp="2tyun64ieoox5">
      <a ref={ref} href={CHECKOUT_URL} className="group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[16px] font-extrabold uppercase leading-snug tracking-wide text-white shadow-[0_6px_0_0_#0F6B32] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-dark active:translate-y-[4px] active:shadow-[0_2px_0_0_#0F6B32] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:px-8 sm:text-lg" data-id="element-102" data-mp="2tx03etivf2un">
        <span className="text-balance" data-id="element-103" data-mp="199eqmxq5happ">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-104" data-mp="19azj8hswmjkx" />
      </a>
      {sublabel && <p className={`mt-4 max-w-xl text-center text-[13px] leading-relaxed sm:text-sm ${tone === 'dark' ? 'text-white/75' : 'text-muted'}`} data-id="element-105" data-mp="1ibny1eq4gnyv">
          {sublabel}
        </p>}
    </div>;
});